var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('hero-header',{attrs:{"page-name":_vm.$store.state.DeviceManagement.deviceDisplayName,"hero-title":"personalInformations"}}),_c('personal-details-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }